import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import {unregister} from './registerServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

unregister()
